import React from "react";

import Portal from "../../components/portal";
import { PropTypeShapes } from "../../types";
import uniqueId from "../../utils/uniqueId";
import createDomNode from "./createDomNode";

let portalClassName = "appPortal";

import "./portal.scss";

class AppPortal extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.createNodes();
  }

  componentWillUnmount() {
    this._portalNode.removeEventListener("click", this.onBackdropClick);
    if (this._portalNode) {
      this._portalNode.remove();
    }
    this._portalNode = null;
  }

  createNodes() {
    let classNames = [portalClassName];
    //#!if iOS === true
// classNames.push("ios");
    //#!endif
    //#!if mobile === true
// classNames.push("mobile");
    //#!endif
    //#!if tablet === true
// classNames.push("tablet");
    //#!endif
    //#!if desktop === true
    classNames.push("desktop");
    //#!endif

    this._portalId = "x" + uniqueId();
    this._portalNode = createDomNode(null, this._portalId, classNames);
  }

  render() {
    return <Portal targetDomId={this._portalId}>{this.props.children}</Portal>;
  }
}

AppPortal.propTypes = {
  children: PropTypeShapes.elementOrArray
};

export default AppPortal;
